import React from 'react';
import { Wrench } from 'lucide-react';
import { useSystemSettings } from '../../hooks/useSystemSettings';

const MaintenanceBanner: React.FC = () => {
  const { isLoading, getBoolean } = useSystemSettings();

  if (isLoading) {
    return null;
  }

  const maintenanceMode = getBoolean('maintenance_mode', false);

  if (!maintenanceMode) {
    return null;
  }

  return (
    <div className="w-full border-b border-amber-300 bg-amber-100 text-amber-900">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-sm font-medium">
        <Wrench className="h-4 w-4" />
        <span>
          Maintenance mode is currently enabled. Some features may be temporarily unavailable.
        </span>
      </div>
    </div>
  );
};

export default MaintenanceBanner;